import React, {Component} from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import api from '../../utils/api';
import Title from '../base/title';
import Cta from '../base/cta';
import SimulacionIntro from './simulacionintro';
import SimulacionOutro from './simulacionoutro';
import SimulacionSave from './simulacionsave';
import ClusterStrategy from './clusterstrategy';
import Modal from '../base/modal';
import {limitTwoDecimals} from '../../utils/helpers';
import { ToastContainer, toast } from 'react-toastify';

class Simulacion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: ' loader-box',
            modalVisible: false,
            data: {},
            processedData : {
              details: {
                general_simulation: {
                  shell: [],
                  pm: []
                },
                cluster_simulation_list: []
              }
            },
            clusters: [],
            priceTitles: {
                1: "Diferencial Estrategia Cluster (%)",
                2: "Diferencial Historico (%)",
                3: "Precio Referencia Actual",
                4: "Precio PM Actual",
                5: "Diferencial Actual (%)",
                6: "Aumento Hipotético PM (%)",
                7: "Precio Hipotético PM",
                8: "Diferencial Hipotético (%)",
                9: "Nuevo Precio Referencia",
                10: "Nuevo Diferencial (%)",
                11: "Aumento (%)",
            },
            fieldTitles : {
                1:"strategy_difference",
                2:"historic_difference",
                3:"actual_reference_price",
                4:"actual_pm_pvp",
                5:"actual_difference",
                6:"hypothetical_increase",
                7:"hypothetical_price",
                8:"hypothetical_difference",
                9:"new_reference_price",
                10:"new_difference",
                11:"new_increase"
            }
        }

        this.calculatePrices = this.calculatePrices.bind(this);
        this.checkIncreasePrice = this.checkIncreasePrice.bind(this);
        this.checkNewRefPrice = this.checkNewRefPrice.bind(this);
        this.checkFinalSimulation = this.checkFinalSimulation.bind(this);
        this.setSimulationStatus = this.setSimulationStatus.bind(this);
    }

    componentWillMount(){
      let _self = this;
      let editId = _self.props.editId;
      let clusters = [];

      if(editId){
        api.get("simulations/id/"+editId).then(out =>{
          let data = out.data;
          data.details = JSON.parse(data.details);
          if (data.details.cluster_simulation_list) {
              clusters = _self.renderClusters(data.details.cluster_simulation_list);
          }
          _self.setState({data: data, processedData: data, clusters: clusters, loader: ''});
        })
      }
    }

    renderClusters(arr){
      let _self = this;
      let clusters = [];
      arr.forEach(cluster => {
        let obj = {
          id: cluster.cluster_id,
          name: cluster.cluster_name,
          prices: {}
        };
        for (let i = 1; i <= Object.keys(_self.state.priceTitles).length; i++) {
          obj.prices[_self.state.priceTitles[i]] = {};
        }
        cluster.products_table.forEach(p => {
          for (let i = 1; i <= Object.keys(_self.state.priceTitles).length; i++) {
            obj.prices[_self.state.priceTitles[i]][p.product_name] = p[_self.state.fieldTitles[i]] !== null ? limitTwoDecimals(p[_self.state.fieldTitles[i]]) : null;
          }
        });
        clusters.push(obj);
      });
      return clusters;
    }

    calculatePrices(newData, formula, staticValue, limitCluster){
      let _self = this;
      let data = newData.details !== undefined ? newData : JSON.parse(JSON.stringify(_self.state.processedData));

      if(data) {
        let prices = {};
        let pricesPM = {};

        let details = data.details;

        // Map simulacionintro values
        if (details.general_simulation) {
          details.general_simulation.shell.forEach(e => {              
              prices[e.product_shortname] = {};
              prices[e.product_shortname].price_increase = parseFloat(e.price_increase);
              prices[e.product_shortname].min_price = parseFloat(e.min_price);
              prices[e.product_shortname].max_price = parseFloat(e.max_price);
          });
          details.general_simulation.pm.forEach(e => {
              pricesPM[e.product_shortname] = {};
              prices[e.product_shortname].pm_price_increase = parseFloat(e.price_increase);
          });
        }

        // do math
        formula = formula ? formula : 'basadoEnAumento';  
        if (details.cluster_simulation_list){
          details.cluster_simulation_list.forEach(cluster => {
            if (limitCluster && limitCluster !== cluster.cluster_id) return;
            if (limitCluster) cluster.locked = true;
            if (!staticValue && cluster.locked) return;

            cluster.products_table.forEach(p => {
                let price = prices[p.product_shortname];
                p = _self[formula](p, price, staticValue ? staticValue[p.product_name] : price.price_increase);
            })
          });
        }

        let _state = _self.state;
        _state.processedData = data;
        _state.clusters = _self.renderClusters(data.details.cluster_simulation_list);
        _self.setState(_state);
      }
    }

    basadoEnAumento(p, price, staticValue) {
      // Aumento (%)
      p.new_increase = staticValue;
      
      // Aumento Hipotético PM (%)
      //p.hypothetical_increase = price.pm_price_increase;

      // Precio Hipotético PM
      p.hypothetical_price = (p.actual_pm_pvp*(1+(p.hypothetical_increase/100)));

      // Diferencial Hipotético (%)
      p.hypothetical_difference = (p.actual_reference_price/p.hypothetical_price)-1;

      // Nuevo Precio Referencia
      p.new_reference_price = p.actual_reference_price*((p.new_increase/100)+1);

      // Nuevo Diferencial (%)
      p.new_difference = (p.new_reference_price/p.hypothetical_price)-1;

      p.new_difference = p.new_difference * 100;
      p.hypothetical_difference = p.hypothetical_difference * 100;

      return p;
    }

    basadoEnNuevoDifrencial(p, price, staticValue) {
      // Nuevo Diferencial (%)
      p.new_difference = staticValue;
      
      // Aumento Hipotético PM (%)
      //p.hypothetical_increase = price.pm_price_increase;

      // Precio Hipotético PM
      if(price.pm_price_increase === 0)
        p.hypothetical_price = p.actual_pm_pvp
      else
        p.hypothetical_price = (p.actual_pm_pvp*(1+(p.hypothetical_increase/100)))

      // Diferencial Hipotético (%)
      p.hypothetical_difference = (p.actual_reference_price/p.hypothetical_price)-1;

      // Nuevo Precio Referencia
      p.new_reference_price = ((p.new_difference/100)+1)*p.hypothetical_price

      // Aumento (%)
      p.new_increase = ((p.new_reference_price/p.actual_reference_price)-1)*100;

      //p.new_difference = p.new_difference * 100;
      p.hypothetical_difference = p.hypothetical_difference * 100;

      return p;
    }

    basadoEnNuevoPrecioReferencia(p, price, staticValue) {
      // Nuevo Precio Referencia
      p.new_reference_price = staticValue
      
      // Aumento Hipotético PM (%)
      //p.hypothetical_increase = price.pm_price_increase;

      // Precio Hipotético PM
      if(price.pm_price_increase === 0)
        p.hypothetical_price = p.actual_pm_pvp
      else
        p.hypothetical_price = (p.actual_pm_pvp*(1+(p.hypothetical_increase/100)))

      // Diferencial Hipotético (%)
      p.hypothetical_difference = (p.actual_reference_price/p.hypothetical_price)-1;

      // Nuevo Diferencial (%)
      p.new_difference = ((p.new_reference_price/p.hypothetical_price)-1);

      // Aumento (%)
      p.new_increase = ((p.new_reference_price/p.actual_reference_price)-1)*100;

      p.new_difference = p.new_difference * 100;
      p.hypothetical_difference = p.hypothetical_difference * 100;

      return p;
    }

    basadoEnAumentoHipotetico(p, price, staticValue) {
      // Aumento Hipotético PM (%)
      p.hypothetical_increase = staticValue;

      // Precio Hipotético PM
      if(staticValue === 0)
        p.hypothetical_price = p.actual_pm_pvp
      else
        p.hypothetical_price = (p.actual_pm_pvp*(1+(p.hypothetical_increase/100)))

      // Diferencial Hipotético (%)
      p.hypothetical_difference = (p.actual_reference_price/p.hypothetical_price)-1;

      // Nuevo Precio Referencia
      p.new_reference_price = ((p.new_difference/100)+1)*p.hypothetical_price;

      // Nuevo Diferencial (%)
      p.new_difference = ((p.new_reference_price/p.hypothetical_price)-1);

      // Aumento (%)
      p.new_increase = ((p.new_reference_price/p.actual_reference_price)-1)*100;

      p.new_difference = p.new_difference * 100;
      p.hypothetical_difference = p.hypothetical_difference * 100;

      return p;
    }

    checkIncreasePrice(k, viewData){
      this.checkNewRefPrice(k, viewData);
    }

    checkNewRefPrice(k, viewData) {
      let formula = false;
      if (k === 'Nuevo Precio Referencia') {
        formula = 'basadoEnNuevoPrecioReferencia';
      } else if (k === 'Nuevo Diferencial (%)') {
        formula = 'basadoEnNuevoDifrencial';
      } else if (k === 'Aumento Hipotético PM (%)') {
        formula = 'basadoEnAumentoHipotetico';
      }

      this.calculatePrices({}, formula, viewData.prices[k], viewData.id);
    }

    checkFinalSimulation() {

    }

    setSimulationStatus(status){
        let _self = this;
        let _state = _self.state;
        _state.status = status;
        _self.setState(_state);
    }

    render() {
        let _self = this;

        let cancel = {
            text: 'CANCELAR',
            click: () => {
                _self.refs.modal.hide();
            }
        };

        let confirm = {
            text: 'CONFIRMAR',
            click: () => {
                api.delete('simulations/id/' + _self.props.editId + '/').then(resp => {
                    _self.props.switchToStep(1);
                    _self.props.setEditId(null);
                })
            }
        };

        let confirmSave = {
            text: 'CONFIRMAR',
            click: () => {
                let _self = this;
                let save = {
                    status: _self.state.status,
                    details: JSON.stringify(_self.state.processedData.details)
                };

                api.put("simulations/id/"+_self.state.processedData.id, save).then(out => {
                  if(out.status === 200) {
                      window.location.reload();
                  }
                }).catch(e => {
                  toast.error('No se pudo guardar el cluster');
                });
            }
        };

        return (
            <div>
                <Modal ref="modal" visible={_self.state.modalVisible} save={confirm} cancel={cancel}>
                    <p className="red-text">Estas seguro que deseas borrar la simulacion?</p>
                </Modal>
                <Modal ref="modalSave" visible={_self.state.modalVisible} save={confirmSave} cancel={cancel}>
                    <p className="red-text">Estas seguro que deseas guardar la simulacion?</p>
                </Modal>
                <ToastContainer />
                <section className="simulador">
                    <SimulacionSave setStatus={_self.setSimulationStatus} modalRef={_self.refs.modalSave} modifiedDate={_self.state.processedData.modified ? "Borrador guardado " + moment(_self.state.processedData.modified).format("HH:mm") : ""}/>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col s12">
                                <div className="simulador_simulacion_header">
                                    <div className="row vmiddle">
                                        <div className="col s2 no-gutter">
                                            <h2>{_self.state.processedData.name}</h2>
                                        </div>
                                        <div className="col s3 no-gutter">
                                            <div className="simulador_simulacion_header_box">
                                                <span
                                                    className="simulador_simulacion_header_box_change-type">Cambio Proactivo</span>
                                                <span
                                                    className="simulador_simulacion_header_box_cluster-q">({_self.state.processedData.cluster_weights ? _self.state.processedData.cluster_weights.length : 0}) Clusters</span>

                                            </div>
                                        </div>
                                        <div className="col s2 no-gutter">
                                            <span>{_self.state.processedData.modified ? "Borrador guardado " + moment(_self.state.processedData.modified).format("HH:mm") : ""}</span>
                                        </div>
                                        <div className="col s4 no-gutter">
                                            <div className="simulador_simulacion_header_box_btns">
                                                <button type="button" className="cta cta_trash" onClick={() => { _self.refs.modal.show(); }}>
                                                    <i className="far fa-trash-alt"></i>
                                                </button>
                                                <button type="button" className="cta cta_discard" onClick={() => {
                                                    _self.props.switchToStep(1);
                                                    _self.props.setEditId(null);
                                                }}>Descartar Cambios
                                                </button>
                                                <button type="button" className="cta" onClick={() => { _self.setSimulationStatus("DRAFT"); _self.refs.modalSave.show(); }}>Guardar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Title text="SIMULAR CAMBIO PROACTIVO DE PRECIOS" className=''/>

                        <div className="row">
                            <div className="col s12">
                                <div className={"simulador_simulacion_main-content" + this.state.loader}>
                                    <SimulacionIntro calculatePrices={_self.calculatePrices} data={_self.state.processedData} />
                                    {_self.state.clusters.map( (c, key) => {
                                        return <ClusterStrategy key={key} checkFinalSimulation={_self.checkFinalSimulation} checkIncreasePrice={_self.checkIncreasePrice} checkNewRefPrice={_self.checkNewRefPrice} data={c}/>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col s12">
                                <div className="simulador_simulacion_header">
                                    <div className="row vmiddle">
                                        <div className="col s2 no-gutter">
                                            <h2>{_self.state.processedData.name}</h2>
                                        </div>
                                        <div className="col s3 no-gutter">
                                            <div className="simulador_simulacion_header_box">
                                                <span className="simulador_simulacion_header_box_change-type">Cambio Proactivo</span>
                                                <span className="simulador_simulacion_header_box_cluster-q">({_self.state.processedData.cluster_weights ? _self.state.processedData.cluster_weights.length : 0}) Clusters</span>

                                            </div>
                                        </div>
                                        <div className="col s2 no-gutter">
                                            <span>{_self.state.processedData.modified ? "Borrador guardado " + moment(_self.state.processedData.modified).format("HH:mm") : ""}</span>
                                        </div>
                                        <div className="col s4 no-gutter">
                                            <div className="simulador_simulacion_header_box_btns footer-btns">
                                                <Cta click={() => { api.get('simulations/id/' + _self.props.editId + '/export/').then(resp => { window.open(api.marker(resp.data.url)); }) } } text=".XLSX" downloadIcon centered className="sm"/>
                                                <Cta click={() => { _self.setSimulationStatus("INFORMED"); _self.refs.modalSave.show(); }} text="IMPACTAR EN LA HERRAMIENTA" toolIcon centered
                                                     className="lg red-border"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <SimulacionOutro data={_self.state.processedData}/>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Simulacion);



// WEBPACK FOOTER //
// ./src/containers/simulador/simulacion.js